export const PRIVACY_DECLINE_ALL = 'declineAll';

export const PRIVACY_CONSENT_ALL = 'consentAll';

export const PRIVACY_SELECT = 'selectPrivacy';
